import * as React from 'react';
import ReactTable, { Column } from 'react-table';
import { ContractTermSearchViewModel } from '@models/ContractHistory';
import * as moment from 'moment';
import { CoverageOption } from '@models/CoverageOption';

export interface ContractHistoryComponentProperties {
  readonly contractId?: number;
  readonly message: string;
  readonly query: string | null;
  readonly showInactive?: boolean | undefined;
  readonly loading: boolean;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly pageCount: number;
  readonly results: Array<ContractTermSearchViewModel>;
  readonly getContractHistory: (
    query: string | null,
    pageSize: number,
    pageNumber: number,
    orderBy: string,
    orderDirection: string,
    contractId?: number
  ) => void;
}

export class ContractHistoryComponent extends React.Component<ContractHistoryComponentProperties> {
  private isInitialized = false;

  componentDidMount() {
    if (this.props.contractId) {
      this.handleSearch('');
    }
  }

  render() {
    let columns: Column[] = [
      {
        accessor: 'termNumber',
        width: 60,
        Header: 'Term#',
        sortable: true
      },
      {
        accessor: (ct: ContractTermSearchViewModel) => (!ct.startDate ? '---' : moment(ct.startDate).format('L')),
        id: 'startDate',
        width: 120,
        Header: 'Start',
        sortable: false
      },
      {
        accessor: (ct: ContractTermSearchViewModel) => (!ct.endDate ? '---' : moment(ct.endDate).format('L')),
        id: 'endDate',
        Header: 'End',
        sortable: true,
        width: 120
      },
      {
        accessor: (ct: ContractTermSearchViewModel) => (!ct.holdDate ? '---' : moment(ct.holdDate).format('L')),
        id: 'holdDate',
        Header: 'On Hold',
        sortable: true,
        width: 120
      },
      {
        accessor: (ct: ContractTermSearchViewModel) => (!ct.cancelDate ? '---' : moment(ct.cancelDate).format('L')),
        id: 'cancelDate',
        Header: 'Cancel',
        sortable: true,
        width: 120
      },
      {
        accessor: (ct: ContractTermSearchViewModel) => (!ct.suspendDate ? '---' : moment(ct.suspendDate).format('L')),
        id: 'suspendDate',
        Header: 'Suspend',
        sortable: true,
        width: 120
      },
      {
        id: 'productValue',
        accessor: 'product.value',
        Header: 'Product',
        sortable: true,
        width: 190
      },
      {
        accessor: (ct: ContractTermSearchViewModel) => (ct.totalPrice ? '$' + ct.totalPrice.toFixed(2) : '---'),
        id: 'totalPrice',
        Header: 'A/R Price',
        sortable: true,
        width: 100
      },
      {
        accessor: (ct: ContractTermSearchViewModel) => (ct.totalPaid ? '$' + ct.totalPaid.toFixed(2) : '---'),
        id: 'totalPaid',
        Header: 'Receipts',
        sortable: true,
        width: 100
      }
    ];

    let columnsChildren: Column[] = [
      {
        accessor: 'value',
        width: 870,
        Header: 'Coverage',
        sortable: true
      },
      {
        accessor: (co: CoverageOption) => (co.value === 'TOTAL' ? '' : co.sellerCoverage ? 'Yes' : 'No'),
        id: 'sellerCoverage',
        width: 60,
        Header: 'Seller',
        sortable: true
      },
      {
        accessor: (co: CoverageOption) =>
          co.price
            ? co.priceAdjustment
              ? 'A $' + (co.price + co.priceAdjustment).toFixed(2)
              : '$' + co.price.toFixed(2)
            : '---',
        id: 'price',
        width: 100,
        Header: 'Price',
        sortable: true
      }
    ];

    return (
      <div>
        <ReactTable
          onPageChange={() => {
            Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
              element.scrollTop = 0;
            });
          }}
          className="-striped -highlight"
          columns={columns}
          data={this.props.results}
          defaultPageSize={10}
          loading={this.props.loading}
          manual={true}
          onFetchData={this.handleFetchData}
          pages={this.props.pageCount}
          SubComponent={row => {
            return (
              <div style={{ padding: '20px' }}>
                <ReactTable
                  data={row.original.coverageOptions}
                  columns={columnsChildren}
                  defaultPageSize={row.original.coverageOptions.length}
                  showPagination={false}
                />
              </div>
            );
          }}
        />
      </div>
    );
  }
  private handleFetchData = (state: {
    page: number;
    pageSize: number;
    sorted: Array<{ id: string; desc: boolean }>;
  }): void => {
    if (this.isInitialized) {
      const orderBy = state.sorted[0] ? state.sorted[0].id : 'termNumber';
      const orderDirection = state.sorted[0] ? (state.sorted[0].desc ? 'desc' : 'asc') : 'desc';
      this.props.getContractHistory(
        this.props.query,
        state.pageSize,
        state.page + 1,
        orderBy,
        orderDirection,
        this.props.contractId
      );
    }
    this.isInitialized = true;
  };

  private handleSearch = (query: string): void => {
    this.props.getContractHistory(query, this.props.pageSize, 1, 'termNumber', 'desc', this.props.contractId);
  };
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-history/contract-history.component.tsx